import AssignPage from './components/AssignPage';
import './index.scss';

const Assign = () => {
  return <AssignPage />;
};

export default Assign;
